import React from 'react'

export const TimelineRoute = ({title,description,year}) => {
  return (
                <div className="timeline">
                    <a href="#" className="timeline-content">
                        <div className="timeline-year">{year}</div>
                        <h3 className="title">{title}</h3>
                        <p className="description">
                            {description}
                        </p>
                    </a>
                </div>
  )
}
